import { render, staticRenderFns } from "./ModalAdicionarModelo.vue?vue&type=template&id=d071290c"
import script from "./ModalAdicionarModelo.vue?vue&type=script&lang=ts"
export * from "./ModalAdicionarModelo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports